import { createTheme, responsiveFontSizes } from "@mui/material";
import { deepmerge } from "@mui/utils";
import { useEffect, useState } from "react";
import { useLazyLoadQuery } from "react-relay";
import settings from "../../../../../appsettings.json";
import axios, { axiosPrivate } from "../../../api/axios";
import { LogLevel } from "../../hooks/useLogging/Logging-types";
import { useLogging } from "../../hooks/useLogging/useLogging";
import { ThemeQuery } from "./ThemeQuery";
import { configureClientTheme, useMealTrackThemeConfigurations } from "./mealTrackThemeConfigurations";
/**
 * Fetches branding for current company
 *
 * @return {*}
 */
export const useBrandingFetch = () => {
    const { MT_THEME, DEFAULT_FONTS } = useMealTrackThemeConfigurations();
    const data = useLazyLoadQuery(ThemeQuery, {});
    const clientThemeConfigurations = configureClientTheme(data.theme.theme);
    const [loading, setLoading] = useState(true);
    const [branding, setBrand] = useState(undefined);
    const [fontsUsed, setFontsUsed] = useState(DEFAULT_FONTS);
    // Merge default theme configurations with client-specific configurations.
    // - MT_THEME is the default Meal Track theme.
    // - clientThemeConfigurations contains theme configurations specific to the client.
    // - Using deepmerge combines the two objects, with clientThemeConfigurations taking precedence.
    const theme = createTheme(deepmerge(MT_THEME, clientThemeConfigurations));
    const responsiveFontTheme = responsiveFontSizes(theme);
    const { datadogLog } = useLogging();
    useEffect(() => {
        axiosPrivate
            .get(`/React/GetBrand`)
            .then(({ data }) => {
            const branding = data.branding;
            let arrFontFamiliesUsed = [];
            for (let key in branding) {
                const item = branding[key];
                if (item.FontStyle) {
                    const familyToAdd = getFontFamily(item.FontStyle);
                    if (!arrFontFamiliesUsed.includes(familyToAdd)) {
                        arrFontFamiliesUsed.push(familyToAdd);
                    }
                }
            }
            let requestData = {
                key: settings.GoogleFontsApiKey,
                family: arrFontFamiliesUsed,
            };
            const queryString = Object.keys(requestData)
                .map((key) => {
                if (Array.isArray(requestData[key])) {
                    return requestData[key]
                        .map((value) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                        .join("&");
                }
                return `${encodeURIComponent(key)}=${encodeURIComponent(requestData[key])}`;
            })
                .join("&");
            let fonts = new Array();
            axios.get(`https://www.googleapis.com/webfonts/v1/webfonts?${queryString}`).then(({ data }) => {
                //For Each, push available weights into array of fonts to load.
                data.items.forEach((item) => {
                    fonts.push({ font: item.family, weights: item.variants });
                });
                // Combine the fonts from the API with the default fonts
                setFontsUsed((prev) => [...prev, ...fonts]);
            });
            setBrand(branding);
        })
            .catch((e) => {
            var _a;
            console.error(e);
            datadogLog((_a = e.message) !== null && _a !== void 0 ? _a : "Error in branding fetch", LogLevel.ERROR, {}, e);
        })
            .then(() => setLoading(false));
    }, []);
    return {
        loading,
        branding,
        fonts: fontsUsed,
        theme: responsiveFontTheme,
    };
};
export const getFontFamily = (nameWeightString) => {
    return nameWeightString.trim().split(":")[0];
};
export const getFontWeight = (nameWeightString) => {
    return parseInt(nameWeightString.trim().split(":")[1]);
};
